import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'communityMember',
      method: 'get',
      request: (communityId, organisationId, t) => ({
        url: apiRoutes.communityMembersV2(communityId, organisationId),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getCommunityMembershipFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
